import { apiRequest } from '../core/http';
import type { OrganizationDto } from './admin-organizations.api';

/** GET/PATCH /v1/me/organization return the organization DTO, counts included. */
export type MyOrganization = OrganizationDto;

export function getMyOrganization() {
  return apiRequest<MyOrganization>('get', '/v1/me/organization');
}

export function updateMyOrganization(name: string) {
  return apiRequest<MyOrganization>('patch', '/v1/me/organization', { name });
}
